import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Home, ArrowLeft } from "lucide-react";

export default function NotFoundPage() {
  return (
    <main data-testid="not-found-page" className="min-h-screen flex items-center justify-center">
      <div className="text-center px-6">
        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5 }}
        >
          <span className="font-mono text-[120px] md:text-[180px] font-bold text-white/5 leading-none block">
            404
          </span>
        </motion.div>
        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
          className="font-heading text-3xl md:text-4xl font-bold text-white tracking-tight -mt-8 mb-4"
        >
          Page Not Found
        </motion.h1>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
          className="text-slate-400 text-base mb-10 max-w-md mx-auto"
        >
          The page you're looking for doesn't exist or has been moved. Let's get you back on track.
        </motion.p>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4 }}
          className="flex flex-col sm:flex-row gap-4 justify-center"
        >
          <Link
            to="/"
            data-testid="404-home-link"
            className="inline-flex items-center gap-2 bg-teal-primary hover:bg-teal-dark text-white font-bold text-sm px-6 py-3 rounded transition-colors duration-200"
          >
            <Home size={16} /> Go Home
          </Link>
          <Link
            to="/contact"
            data-testid="404-contact-link"
            className="inline-flex items-center gap-2 border border-slate-700 hover:border-white text-white font-semibold text-sm px-6 py-3 rounded transition-colors duration-200"
          >
            <ArrowLeft size={16} /> Contact Us
          </Link>
        </motion.div>
      </div>
    </main>
  );
}
